import { Getters } from 'vuex-smart-module';
import AnalyticsState from './state';

export default class AnalyticsGetters extends Getters<AnalyticsState> {}
